import { render, staticRenderFns } from "./HealthResolve.vue?vue&type=template&id=70bcb468&scoped=true&"
import script from "./HealthResolve.vue?vue&type=script&lang=js&"
export * from "./HealthResolve.vue?vue&type=script&lang=js&"
import style0 from "./HealthResolve.vue?vue&type=style&index=0&id=70bcb468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bcb468",
  null
  
)

export default component.exports